import { ITag } from "@edgetier/watchtower-types";

/**
 * Sort all tags alphabetically.
 * @param tags All tags retrieved from the backend.
 * @returns    Tags sorted by name.
 */
export const sortTags = (tags: ITag[]) => tags.sort((one, two) => one.tag.localeCompare(two.tag));
